<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="80%">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>{{ title }}</span>
            </v-card-title>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="table.headers"
              :items="table.data"
              :items-per-page="10"
              :loading="table.loading"
              item-key="id"
              :search="search"
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <template
                v-for="header in table.headers.filter((header) =>
                  header.hasOwnProperty('formatter')
                )"
                v-slot:[`item.${header.value}`]="{ value }"
              >
                {{ header.formatter(value) }}
              </template>
            </v-data-table>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel">
                Close
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import Snackbar from "../Snackbar.vue";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "ChangeNapDialog",
  components: {
    Snackbar,
  },
  data() {
    return {
      dispatchStatus: [],
      assignToList: [],

      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      search: "",
      title: "",

      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: true,
        headers: [
          {
            text: "Serial Number",
            sortable: false,
            value: "serialNumber",
          },
          {
            text: "Reference Number",
            sortable: false,
            value: "referenceNumber",
          },
          { text: "Account Number", sortable: false, value: "accountNumber" },
          {
            text: "JO Number",
            sortable: false,
            value: "joNumber",
          },
          { text: "OLT Name", sortable: false, value: "oltName" },
          { text: "OLT IP", sortable: false, value: "oltIp" },
          { text: "Frame", sortable: false, value: "frame" },
          { text: "Slot", sortable: false, value: "slot" },
          { text: "Port", sortable: false, value: "port" },
          { text: "ONU Id", sortable: false, value: "onuId" },
          { text: "Status", sortable: false, value: "status" },
          { text: "Reason", sortable: false, value: "reason" },

          {
            text: "Date/Time Created",
            value: "createdDate",
            formatter: (x) =>
              x ? moment(x).format("MMM DD, YYYY h:mm:ss A") : null,
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    open(data, title = "Change NAP") {
      this.dialog = true;
      this.title = title;

      this.selectedData = data;
      //
      setTimeout(() => {
        this.table.data = data;
        this.table.loading = false;
      }, 500);
      // this.getDispatchConfig();
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      // this.$refs.form.reset();
      this.dialog = false;
    },
  },

  created() {},
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
